import { render } from "./UpcomingEvents.vue?vue&type=template&id=39f09cc6"
const script = {}

import "./UpcomingEvents.vue?vue&type=style&index=0&id=39f09cc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__